import { render, staticRenderFns } from "./TextRecommendationModal.vue?vue&type=template&id=66e6825d&scoped=true"
import script from "./TextRecommendationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationModal.vue?vue&type=style&index=0&id=66e6825d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6825d",
  null
  
)

export default component.exports